import { render, staticRenderFns } from "./casitem.vue?vue&type=template&id=c5c62b12"
import script from "./casitem.vue?vue&type=script&lang=js"
export * from "./casitem.vue?vue&type=script&lang=js"
import style0 from "./casitem.vue?vue&type=style&index=0&id=c5c62b12&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports